// @ts-nocheck
export function formatDateTime(date) {
  const options = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: true
  };

  const formattedDateTime = new Intl.DateTimeFormat('en-US', options).format(date);

  return formattedDateTime;
}

export function formatDate(date) {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');

  return `${year}-${month}-${day}`;
}

export function formatToHumanDate(date) {
  const options = {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  };

  return date.toLocaleDateString('en-US', options);
}

export function getFirstDayOfNextMonth() {
  const currentDate = new Date();

  currentDate.setMonth(currentDate.getMonth() + 1);
  currentDate.setDate(1);

  return currentDate;
}

export function isBetween7to9 () {
  const now = new Date();
  const currentUTCHour = now.getUTCHours();

  // Check if current hour is between 7 and 9 (inclusive)
  return (currentUTCHour >= 7 && currentUTCHour <= 9) || (currentUTCHour >= 19 && currentUTCHour <= 21);
};
